
import React, { Component } from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import isArray from 'lodash/isArray';

import OpenLayersMap from '../../openlayers/OpenLayersMap';
import MapCommander from '../../openlayers/MapCommander';
import OlMapPluginHint from '../../openlayers/OlMapPluginHint';
import { dispatchEventWithGeneric, Log, getModules } from '../../../core';
import { getLayerIdFromFeature } from '../../openlayers/olUtils';

import createEventFeatureClick from '../../events/featureClick';

const log = Log.getLogger('MultiSceneForApp.map.components.map.MapBase');

class MapBase extends Component {

    classNames = mergeStyleSets({
        root: {
        }
    })

    createMap(map, layers) {
        this._olMap = new OpenLayersMap({
            appConfig: this.props.appConfig,
            interactions: this.props.olInteractions,
            onChangeView: this.handleChangeView,
            onFeatureClick: this.handleFeatureClick,
            onFeaturesFind: this.handleFeaturesFind,
            onShowMessage: this.handleShowMessage,
            onMapToolExecute: this.handleMapToolExecute
        });

        this._olMap.createMap(
            this.refs.mapContainer,
            map.definition,
            this.getViewState(map, layers)
        );

        this._mapCommander = new MapCommander({
            olMap: this._olMap,
            onCommandExecuted: this.handleMapCommanderOnCommandExecuted
        });

        let modules = getModules();
        modules.forEach(item => {
            item.execModuleFunction(
                'initOpenLayersMap',
                {
                    olMap: this._olMap,
                    mapCommander: this._mapCommander
                });
        });

        this._olMapPluginHint = new OlMapPluginHint({
            olMap: this._olMap,
            mapLayersDefinition: this.props.mapLayersDefinition
        });
        this._olMapPluginHint.init();
    }

    componentDidMount() {
        if (this.props.map.definition) {
            this.createMap(this.props.map, this.props.layers);

            // ToDo: is this correct for initialize parent state?
            this.handleChangeView(
                this._olMap.getView().getCenter(),
                this._olMap.getView().getZoom(),
                this._olMap.getView().getRotation(),
                this._olMap.getView().getResolution()
            );
        }
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.map.definition !== this.props.map.definition) && (nextProps.map.definition) && (nextProps.extent)) {
            this.createMap(nextProps.map);
        }

        if (nextProps.layers !== this.props.layers) {
            this.changeLayerVisibility(nextProps.layers);
        }

        if (nextProps.map.commands.list !== this.props.map.commands.list) {
            if (nextProps.map.commands.list.length > 0) {
                this.execCommand(nextProps.map.commands.list[0]);

            }
        }
        if (nextProps.toolsMode !== this.props.toolsMode) {
            if (
                (this.props.toolsMode === 'MEASURE') &&
                (nextProps.toolsMode !== 'MEASURE')
            ) {
                this.measureClear();
            }
        }
    }

    changeLayerVisibility(virtualLayers) {
        this._olMap.changeLayerVisibility(virtualLayers);
    }

    execCommand(command) {
        this._mapCommander.execute(command);
    }

    getMapCenter(mapState) {
        let center = mapState.center || mapState.definition.center;
        if (!center && mapState.definition.extent) {
            let extent = mapState.definition.extent;
            if (isArray(extent) && (extent.length === 4)) {
                center = [
                    (extent[0] + extent[2]) / 2,
                    (extent[1] + extent[3]) / 2
                ];
            }
        }
        if (this.props.queryParams && this.props.queryParams.coord) {
            try {
                const coords = this.props.queryParams.coord.split(',');
                center = [
                    parseInt(coords[0], 10),
                    parseInt(coords[1], 10)
                ];
            } catch (e) {
                // nop;
            }
        }
        return center;
    }

    getMapDefaultExtension(mapState) {
        return mapState.definition.extent;
    }

    getMapZoom(mapState) {
        let zoom = mapState.zoom || mapState.definition.zoom;
        if (this.props.queryParams && this.props.queryParams.zoom) {
            try {
                zoom = parseInt(this.props.queryParams.zoom, 10);
            } catch (e) {
                // nop;
            }
        }
        return zoom;
    }

    getLayers(layers) {
        return [
            ...layers
        ];
    }

    getOlMap() {
        return this._olMap;
    }

    getViewState(map, layers) {
        return {
            center: this.getMapCenter(map),
            defaultExtent: this.getMapDefaultExtension(map),
            rotation: map.rotation,
            zoom: this.getMapZoom(map),
            layers: this.getLayers(layers)
        };
    }

    getVisibleLayers() {
        return this.props.layers.filter(item => {
            return (item.visible);
        }).map(item => {
            return item.id;
        });
    }

    handleShowMessage = (message) => {
        if (this.props.onShowMessage) {
            this.props.onShowMessage(message);
        }
    }

    handleChangeView = (center, zoom, rotation, resolution) => {
        if (this.props.onChangeView) {
            this.props.onChangeView(center, zoom, rotation, resolution);
        }
    }

    handleFeatureClick = (feature) => {
        if (this.props.onFeatureClick) {
            this.props.onFeatureClick(feature);
        }
        // ToDo: pass geometry to event (what format to use - GeoJSON, WKT, ... ???)
        let {geometry, ...properties} = feature.getProperties();
        dispatchEventWithGeneric(
            createEventFeatureClick(
                getLayerIdFromFeature(feature), properties
            )
        );
    }

    handleFeaturesFind = (features, finished, coordinates) => {
        if (this.props.onFeaturesFind) {
            this.props.onFeaturesFind(features, finished, coordinates);
        }
    }

    handleMapCommanderOnCommandExecuted = (id) => {
        if (this.props.moduleActions) {
            this.props.moduleActions.removeCommand(id);
        }
    }

    handleMapToolExecute = (toolId, params) => {
        if (this.props.onMapToolExecute) {
            this.props.onMapToolExecute(toolId, params);
        }
    }

    measureClear() {
        this.execCommand({
            name: 'CLEAR_ALL_MEASURE',
            params: {}
        })
    }

    render() {
        return (
            <div key="map" ref="mapContainer" tabIndex="99" ></div>
        );
    }

    updateSize() {
        if (this._olMap && this.refs.mapContainer) {
            let size = [
                this.refs.mapContainer.clientWidth,
                this.refs.mapContainer.clientHeight
            ];
            this._olMap.getMap().setSize(size);
        }
    }
};

export default MapBase;
